<template>
    <div class="mainDiv">
      <h1>申请经销商</h1>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="姓名" prop="contactPerson">
          <el-input v-model="ruleForm.contactPerson" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="enterprisePersonNumber">
          <el-input v-model="ruleForm.enterprisePersonNumber" type="number" oninput="if(value.length>18)value=value.slice(0,18)" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="企业名称" prop="companyName">
          <el-input v-model="ruleForm.companyName" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="ruleForm.phone" type="number" oninput="if(value.length>11)value=value.slice(0,11)" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="联系地址" prop="address">
          <el-input v-model="ruleForm.address" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="身份证正面" prop="frontIdcardPic">
          <div class="imgDiv">
            <img v-if="ruleForm.frontIdcardPic" :src="ruleForm.frontIdcardPic" class="avatar">
            <el-upload
              name="files"
              class="avatar-uploader"
              :action="`${$baseUrl}/custom/xunyou/api/common/upload`"
              :show-file-list="false"
              :on-success="handleAvatarSuccess1">
              <i class="el-icon-plus avatar-uploader-icon" style="width: 100px;height: 100px;border: 1px dashed #999;line-height: 100px;background:#F8F8FF"/>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="身份证反面" prop="backIdcardPic">
          <div class="imgDiv">
            <img v-if="ruleForm.backIdcardPic" :src="ruleForm.backIdcardPic" class="avatar">
            <el-upload
              name="files"
              class="avatar-uploader"
              :action="`${$baseUrl}/custom/xunyou/api/common/upload`"
              :show-file-list="false"
              :on-success="handleAvatarSuccess2">
              <i class="el-icon-plus avatar-uploader-icon" style="width: 100px;height: 100px;border: 1px dashed #999;line-height: 100px;background: #F8F8FF"></i>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="营业执照" prop="businessLicense">
          <div  class="imgDiv">
            <img v-if="ruleForm.businessLicense" :src="ruleForm.businessLicense" class="avatar">
            <el-upload
              name="files"
              class="avatar-uploader"
              :action="`${$baseUrl}/custom/xunyou/api/common/upload`"
              :show-file-list="false"
              :on-success="handleAvatarSuccess3">
              <i class="el-icon-plus avatar-uploader-icon" style="width: 100px;height: 100px;border: 1px dashed #999;line-height: 100px;background: #F8F8FF"></i>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')" style="width: 300px">立即创建</el-button>
        </el-form-item>
      </el-form>
    </div>
</template>

<script>
  import { mercharnt_add, getMercharntStatus } from "@/api/dealerSettled";
  import {mapState} from 'vuex'
    export default {
        name: "dealerSettled",
      data() {
        return {
          userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
          ruleForm: {
            sellerAccount: '',
            contactPerson: '',
            enterprisePersonNumber: '',
            companyName: '',
            phone: '',
            address: '',
            frontIdcardPic: '',
            backIdcardPic: '',
            businessLicense: '',
            type: 3
          },
          rules: {
            contactPerson: [
              { required: true, message: '请填写姓名', trigger: 'blur' }
            ],
            enterprisePersonNumber: [
              { required: true, message: '请填写身份证号', trigger: 'blur' }
            ],
            companyName: [
              { required: true, message: '请填写企业名称', trigger: 'blur' }
            ],
            phone: [
              { required: true, message: '请填写联系电话', trigger: 'blur' }
            ],
            address: [
              { required: true, message: '请填写联系地址', trigger: 'blur' }
            ],
            frontIdcardPic: [
              { required: true, message: '请上传身份证正面', trigger: 'change blur' }
            ],
            backIdcardPic: [
              { required: true, message: '请上传身份证反面', trigger: 'change blur' }
            ],
            businessLicense: [
              { required: true, message: '请上传营业执照', trigger: 'change blur' }
            ],
          }
        };
      },
      created() {
          this.getMercharntStatus()
      },
      computed:{

      },
      methods: {
        getMercharntStatus(){
          let that = this;
          let obj = {};
          obj.type = 3
          obj.username = that.userInfo.loginName
          getMercharntStatus(obj).then(res => {
            if (res.code == 0 && res.data.status == '3') { //审核拒绝数据复现
              this.ruleForm.contactPerson = res.data.bXunyouMerchant.contactPerson
              this.ruleForm.enterprisePersonNumber = res.data.bXunyouMerchant.enterprisePersonNumber
              this.ruleForm.companyName = res.data.bXunyouMerchant.companyName
              this.ruleForm.phone = res.data.bXunyouMerchant.phone
              this.ruleForm.address = res.data.bXunyouMerchant.address
              this.ruleForm.frontIdcardPic = res.data.bXunyouMerchant.frontIdcardPic
              this.ruleForm.backIdcardPic = res.data.bXunyouMerchant.backIdcardPic
              this.ruleForm.businessLicense = res.data.bXunyouMerchant.businessLicense
          }
        })
        },
        submitForm(formName) {
          let that = this
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.ruleForm.sellerAccount = that.userInfo.loginName
              mercharnt_add(this.ruleForm).then(res => {
                this.$message.success('提交成功')
                setTimeout(()=>{
                  that.$router.push('/dealerStatus')
                }, 1000);
              })
            } else {
              console.log('this.ruleForm:',this.ruleForm)
              return false;
            }
          });
        },
        resetForm(formName) {
          this.$refs[formName].resetFields();
        },
        handleAvatarSuccess1(res, file) {
          this.ruleForm.frontIdcardPic = res.url
          this.$refs.ruleForm.validateField('frontIdcardPic')
        },
        handleAvatarSuccess2(res, file) {
          this.ruleForm.backIdcardPic = res.url
          this.$refs.ruleForm.validateField('backIdcardPic')
        },
        handleAvatarSuccess3(res, file) {
          this.ruleForm.businessLicense = res.url
          this.$refs.ruleForm.validateField('businessLicense')
        }
      }
    }
</script>

<style scoped>
  .mainDiv{
    margin-top: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .imgDiv{
    display: flex;
  }
.avatar{
  width: 100px;
  height: 100px;
  margin-right: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/dealerSettled/dealerSettled.vue